import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../../../common/Classes';
import Favourite from '../../../common/components/Favourite';
import { FavouriteConstants } from '../../../common/Constants';
import Utils from '../../../common/Utils';

const FavouriteComponent = props => (
  <>
    {props.initialState !== undefined ?
          <div
              data-testid="favourite-component-container"
              className={classnames(
                  props.className,
                  Classes.icons.favouritePosition,
                  Classes.icons.noSelection
              )}
          >
      <Favourite
        exhibitorId={props.exhibitor ? props.exhibitor.id : null}
        packageName={props.exhibitor ? Utils.getPackageName(props.exhibitor.packageId) : Utils.getPackageName(props.product.packageId)}
        name={props.exhibitor ? props.exhibitor.name : props.product.name}
        exhibitorName={props.product ? props.product.exhibitingOrganisationName : null}
        standReference={props.exhibitor ? props.exhibitor.standReference : null}
        logo={props.exhibitor ? props.exhibitor.logo : null}
        triggeringComponent={props.exhibitor ? FavouriteConstants.sourceDirectory : FavouriteConstants.sourceDirectoryProduct}
        initialState={props.initialState}
        dtmData={props.dtmData}
        translations={props.translations}
        showPlanningEnabled={props.showPlanningEnabled}
        organisationGuid={props.exhibitor ? props.exhibitor.organisationGuid : props.product.organisationGuid}
        mainStandHolderName={props.exhibitor ? props.exhibitor.mainStandHolderName : null}
        type={props.type}
        productId={props.product ? props.product.id : null}
        imageUrl={props.product ? props.product.imageUrl : null}
        exhibitingOrganisationId={props.product ? props.product.exhibitingOrganisationId : null}
        isInnovative={props.product ? props.product.isInnovative : null}
        locale={props.product ? props.product.locale : null}
        description={props.product ? props.product.description : null}
        objectID={props.product ? props.product.objectID : null}
        exhibitorLogo={props.product ? props.product.exhibitorLogo : null}
        isPrimaryEventEdition={props.isPrimaryEventEdition}
        handleFollowClick={props.handleFollowClick}
        isMercuryParticipantShow={props.isMercuryParticipantShow}
        component={props.component}
        isPrioritySlotPremiumExhibitor={props.isPrioritySlotPremiumExhibitor}
        isVariantC={props.isVariantC}
      /></div> : null}
  </>
);

FavouriteComponent.propTypes = {
  exhibitor: PropTypes.shape({
    id: PropTypes.string,
    packageId: PropTypes.number,
    organisationGuid: PropTypes.string,
    name: PropTypes.string,
    standReference: PropTypes.string,
    logo: PropTypes.string,
    mainStandHolderName: PropTypes.string
  }),
  translations: PropTypes.object.isRequired,
  initialState: PropTypes.bool,
  showPlanningEnabled: PropTypes.bool.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  type: PropTypes.string,
  product: PropTypes.shape({
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    exhibitingOrganisationId: PropTypes.string,
    isInnovative: PropTypes.bool,
    locale: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    objectID: PropTypes.string,
    exhibitorLogo: PropTypes.string,
    organisationGuid: PropTypes.string,
    exhibitingOrganisationName: PropTypes.string,
    packageId: PropTypes.number
  }),
  dtmData: PropTypes.object,
  isPrimaryEventEdition: PropTypes.bool,
  handleFollowClick: PropTypes.func,
  isMercuryParticipantShow: PropTypes.bool.isRequired,
  component: PropTypes.string,
  isPrioritySlotPremiumExhibitor: PropTypes.bool,
  isVariantC: PropTypes.bool,
};

export default FavouriteComponent;
